import { useState } from 'react';
import { crmTypeLabels } from './crm-config';
import { useCrmOverrideActions } from './crm-override-actions';
import { CrmOverrideModal } from './crm-override-modal';
import { PlatformConfigForm } from './platform-config-form';
import {
  defaultPlatformConfig,
  isPlatformConfigComplete,
  parsePlatformConfig,
  platformConfigForSave,
} from './platform-config';
import type { SystemOrganizationPhoneNumber } from './graphql';

export function PlatformPhoneOverrideModal({
  phoneNumber,
  onClose,
}: {
  phoneNumber: SystemOrganizationPhoneNumber;
  onClose: () => void;
}) {
  const existing = phoneNumber.crmIntegration;

  const [name, setName] = useState(existing?.name ?? `${phoneNumber.phoneNumber} CRM Override`);
  const [config, setConfig] = useState(existing ? parsePlatformConfig(existing.config) : defaultPlatformConfig);
  const { error, isSaving, save } = useCrmOverrideActions(phoneNumber, onClose);

  return (
    <CrmOverrideModal
      typeLabel={crmTypeLabels.platform}
      isExisting={Boolean(existing)}
      name={name}
      onNameChange={setName}
      error={error}
      isSaving={isSaving}
      canSave={isPlatformConfigComplete(config)}
      onSave={() => void save({ name, type: 'platform', config: platformConfigForSave(config) })}
      onClose={onClose}
    >
      <PlatformConfigForm config={config} onConfigChange={setConfig} />
    </CrmOverrideModal>
  );
}
